<template>
  <v-row class="project-budget-fields">
    <v-col cols="12" sm="6">
      <v-text-field ref="total" :value="totalBudget" :label="$t('project.budget.total')" type="number" min="0" step="0.01" suffix="EUR" :readonly="readonly" :rules="[validAmount]" outlined @input="$emit('update:totalBudget', normalize($event))" />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field ref="citius" :value="citiusBudget" :label="$t('project.budget.citius')" type="number" min="0" step="0.01" suffix="EUR" :readonly="readonly" :rules="[validAmount, withinTotal]" outlined @input="$emit('update:citiusBudget', normalize($event))" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    totalBudget: { type: [Number, String], default: null },
    citiusBudget: { type: [Number, String], default: null },
    readonly: { type: Boolean, default: false }
  },
  watch: {
    totalBudget: 'validateBudgets',
    citiusBudget: 'validateBudgets'
  },
  methods: {
    validateBudgets() {
      if (!this.readonly) this.$nextTick(() => {
        if (this.$refs.total) this.$refs.total.validate();
        if (this.$refs.citius) this.$refs.citius.validate();
      });
    },
    normalize(value) { return value === '' || value === undefined ? null : value; },
    empty(value) { return value === '' || value === null || value === undefined; },
    validAmount(value) { return this.empty(value) || (Number.isFinite(Number(value)) && Number(value) >= 0 && /^\d+(\.\d{1,2})?$/.test(String(value))) || this.$t('project.budget.invalid'); },
    withinTotal() { return this.empty(this.citiusBudget) || this.empty(this.totalBudget) || Number(this.citiusBudget) <= Number(this.totalBudget) || this.$t('project.budget.exceedsTotal'); }
  }
};
</script>
